import { Button } from '@shared/models/button.model';
import { Header, Logo } from '../models/backoffice-header.model';
import { TERTIARY_BUTTON } from '@shared/utils/utils.config';

export const HEADER_LOGO_CONFIG: Logo = {
  img: 'assets/img/logo-generalitat-catalunya-vermell.svg',
  alt: 'SCE Home',
};

export const HEADER_CONFIG: Header = {
  titleHead: 'header.title',
  subtitleHead: 'header.subtitle',
  selectorSearch: 'navbarSelector',
  placeholderSearch: 'header.searchbar.placeholder',
  iconFilter: false,
  lastAccessMessage: 'header.userDropdown.lastAccessMessage',
  setPreferencesMessage: 'header.userDropdown.preferencesMenuMessage',
  seeLanguageMessage: 'header.userDropdown.seeLanguage',
  logOutMessage: 'header.userDropdown.logOutMessage',
  iconDots: false,
  notificationBell: true,
};

export const USER_HEADER_BUTTON: Partial<Button> = {
  ...TERTIARY_BUTTON,
  classNameIcon: 'bi bi-chevron-down',
  rightIcon: true,
};
